import {useState, useEffect, useCallback} from 'react';
import {requestJson} from '../api/httpClient';

export default function useDocumentPage(kind, mine, active) {
 const [params, setParams] = useState({page:0,size:25,query:'',nameQuery:'',employeeQuery:'',sort:'id',direction:'desc',startDate:'',endDate:''});
 const [revision,setRevision] = useState(0);
 const [data,setData] = useState({content:[],total:0});
 const [loading,setLoading] = useState(false), [error,setError] = useState('');
 const refresh=useCallback(()=>setRevision(v=>v+1),[]);
 useEffect(()=>{setParams(p=>({...p,page:0}));},[mine]);
 useEffect(()=>{
  if(!active)return;
  let alive=true;
  const controller=new AbortController();
  setLoading(true);setError('');
  const timer=setTimeout(async()=>{
   try {
    const query=new URLSearchParams({...params,mine});
    if(!params.startDate)query.delete('startDate');
    if(!params.endDate)query.delete('endDate');
    const result=await requestJson(`/api/documents/${kind}?${query}`,{signal:controller.signal});
    if(alive){
     if(params.page>0 && !result.content.length && result.total>0){setParams(p=>({...p,page:Math.ceil(result.total/p.size)-1}));}
     else if(params.page>0 && result.total===0){setParams(p=>({...p,page:0}));}
     else setData(result);
    }
   } catch(e){if(alive)setError('Не удалось загрузить документы');}
   finally{if(alive)setLoading(false);}
  },250);
  return()=>{alive=false;clearTimeout(timer);controller.abort();};
 },[kind,mine,active,params,revision]);
 return {...data,params,loading,error,refresh,change:patch=>setParams(p=>({...p,...patch})),setData};
}
